@if (monitoringTypes$ | async; as monitoringTypes) {
  <form autocomplete="off" [formGroup]="form">
    <div
      class="form-group my-3 form-success-highlight"
      [class.form-error-highlight]="!isControlValid('entity_monitoring_type_uuid')">
      <label for="entity_monitoring_type_uuid" class="label pb-0">
        {{ 'screening.set_on_monitoring_modal.form.entity_monitoring_type_uuid' | translate }}
        <span> * </span>
      </label>
      <div class="select-wrapper mt-2">
        <select class="form-control" id="entity_monitoring_type_uuid" formControlName="entity_monitoring_type_uuid">
          @for (monitoringType of monitoringTypes; track monitoringType.uuid) {
            <option [value]="monitoringType.uuid">
              {{ entityMonitoringTypeTranslations[monitoringType.entity_monitoring_type_key] | translate }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="form-group my-3" [class.form-error-highlight]="!isControlValid('monitoring_comment')">
      <label class="label" for="monitoring_comment">
        {{ 'screening.set_on_monitoring_modal.form.monitoring_comment' | translate }}
        <span> * </span>
      </label>
      <textarea class="form-control" id="monitoring_comment" formControlName="monitoring_comment"></textarea>
    </div>
  </form>
} @else {
  <nk-spinner display="inline"></nk-spinner>
}
